import script from "./SelectAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectAgent.vue?vue&type=script&setup=true&lang=js"

import "./SelectAgent.vue?vue&type=style&index=0&id=5ef71585&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef71585"]])

export default __exports__